export default "__VITE_ASSET__zOyQqdNGsn0lL_XEFrarVA__"